import React from 'react';
import { Grid } from '@mui/material';
import { ReactFCC } from '../../interface/react';
import { UserProfile } from '../../interface/user';
import UserGridItem from '../UserGridItem/UserGridItem';

interface UserGridProps {
	users: UserProfile[];
}

const UserGrid: ReactFCC<UserGridProps> = ({ users }) => {
	return (
		<div data-testid="user-grid-component">
			<Grid
				container
				spacing={2}
				sx={{
					my: {
						xs: 1,
						sm: 3,
						md: 4,
					},
				}}
			>
				{users.map((user) => (
					<UserGridItem key={user.id} user={user} />
				))}
			</Grid>
		</div>
	);
};

export default UserGrid;
